import { useKidsPolicy } from "@/components/features/_hooks/use-kids-policy/use-kids-policy";

import { useProductPlanFormModelContext } from "../../../../../context";

export const usePlanKidsPolicy = () => {
	const { viewModel, onSetViewModel } = useProductPlanFormModelContext();
	const { kidsPolicy } = viewModel;

	return useKidsPolicy({ kidsPolicy, onSetViewModel });
};
